//临时性的缓存（下单完成后、重新回到产品列表页 需要清除的缓存）
const temporaryStorage = [
    'productMsg', //产品信息
    'planList', //投保计划
    'priceList', //价格列表
    'orderConfirmData', //订单提交参数
    'groupApplicant', //团体信息
    'downloadJson', //下载文件列表
    'orderConfirmProfessions', //职业类别
    'customerInfo', //人工录单时客户的信息
    'unFinishData', //待完善列表
    'professions', //待完善列表
    'productData', //待完善列表
];

//持久性的缓存，没有特殊情况不做清除处理
const permanentStorage = [

];

//产品相关数据的缓存，没有特殊情况不做清除处理（key和产品id相关）
const productStorage = [
    'industryData-'
]

export const storageUtil = (name, data) => {
    let a = temporaryStorage.filter(item => {
        return item === name
    })
    let b = permanentStorage.filter(item => {
        return item === name
    })
    let c = productStorage.filter(item => {
        return name.indexOf(item) > -1
    })
    if (a.length == 0 && b.length == 0 && c.length == 0) {
        console.error('localStorage key=' + name + ' 未定义')
        return
    }
    if (window.localStorage && name && typeof name === 'string') {
        if (data === undefined) {
            return JSON.parse(window.localStorage.getItem(name))
        } else if (data) {
            window.localStorage.setItem(name, JSON.stringify(data))
        }
    }
}

export const cleanCache  = () => {
    for (let item of temporaryStorage) {
        window.localStorage.removeItem(item)
    }
}



// WEBPACK FOOTER //
// ./src/util/storage.js